var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7196_576",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7196_576)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M9.9998 16.1572C11.5884 14.7672 12.8256 13.4124 13.7113 12.093C14.597 10.7736 15.0398 9.61008 15.0398 8.60258C15.0398 7.13897 14.5641 5.92133 13.6127 4.94967C12.6613 3.978 11.457 3.49216 9.9998 3.49216C8.54258 3.49216 7.33827 3.978 6.38688 4.94967C5.43549 5.92133 4.9598 7.13897 4.9598 8.60258C4.9598 9.61008 5.40265 10.7736 6.28834 12.093C7.17403 13.4124 8.41119 14.7672 9.9998 16.1572ZM9.9998 17.2003C9.85133 17.2003 9.71327 17.1758 9.58563 17.1267C9.45785 17.0776 9.32827 17.0012 9.19688 16.8976C8.79633 16.5556 8.29445 16.089 7.69126 15.4976C7.0882 14.9063 6.50091 14.2424 5.92938 13.5057C5.35771 12.769 4.87265 11.9798 4.47417 11.138C4.0757 10.2961 3.87646 9.45091 3.87646 8.60258C3.87646 6.90175 4.4464 5.44557 5.58626 4.23404C6.72626 3.02251 8.19744 2.41675 9.9998 2.41675C11.7883 2.41675 13.256 3.02251 14.4029 4.23404C15.5497 5.44557 16.1231 6.90175 16.1231 8.60258C16.1231 9.45091 15.9204 10.2981 15.515 11.1442C15.1096 11.9905 14.6259 12.7833 14.064 13.5226C13.5019 14.2619 12.9193 14.9224 12.3163 15.504C11.7132 16.0858 11.2113 16.5477 10.8106 16.8895C10.6812 16.9931 10.5514 17.0708 10.4213 17.1226C10.2913 17.1744 10.1508 17.2003 9.9998 17.2003ZM10.0013 9.88779C10.3742 9.88779 10.6904 9.75751 10.95 9.49696C11.2097 9.2364 11.3396 8.91966 11.3396 8.54675C11.3396 8.17383 11.2093 7.85751 10.9488 7.59779C10.6882 7.33821 10.3714 7.20842 9.99834 7.20842C9.62542 7.20842 9.30917 7.33869 9.04959 7.59925C8.78987 7.8598 8.66001 8.17661 8.66001 8.54966C8.66001 8.92258 8.79028 9.23883 9.05084 9.49841C9.3114 9.758 9.6282 9.88779 10.0013 9.88779Z",
    fill: "#001E63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.eef8c518eceec87ad9e184fdb546165e.svg";
export { ForwardRef as ReactComponent };